import React, { FC, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../config/firebase";
import { useMyContext } from "context/footerContext";

export interface PageSignUpProps {
  className?: string;
}

const PageSignUp: FC<PageSignUpProps> = ({ className = "" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { setValidFooter } = useMyContext();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loadingButton, setLoadingButton] = useState(false);

  const onSubmit = async (e: any) => {
    e.preventDefault();
    setLoadingButton(true);

    await createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        console.log(user);
        navigate("/login");
        setLoadingButton(false);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode, errorMessage);
        setLoadingButton(false);
      });
  };

  useEffect(() => {
    setValidFooter(location.pathname);

    return () => {
      setValidFooter("");
    };
  }, []);

  return (
    <div className={`nc-PageSignUp  ${className}`} data-nc-id="PageSignUp">
      <Helmet>
        <title>Sign up</title>
      </Helmet>
      <div className="container mb-4 lg:mb-8">
        <div className="flex justify-center shadow-[0_0_40px_-15px_rgba(0,0,0,0.3)] rounded-3xl w-full lg:w-[670px] min-h-[700px] mx-auto px-4 lg:px-8 mt-4 lg:mt-8 pb-6 lg:pb-16">
          <div className="w-full">
            <h2 className="my-6 lg:my-10 flex items-center text-xl lg:text-2xl font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
              Sign up
            </h2>
            <div className="mx-auto space-y-4 lg:space-y-6">
              {/* FORM */}
              <form className="grid grid-cols-1 gap-4 lg:gap-6" onSubmit={onSubmit}>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6">
                  <label className="block mb-2">
                    <span className="text-neutral-800 dark:text-neutral-200">
                      Firstname
                    </span>
                    <Input
                      type="text"
                      placeholder="Firstname"
                      className="mt-1 h-12 lg:h-16 rounded-xl"
                    />
                  </label>

                  <label className="block mb-2">
                    <span className="text-neutral-800 dark:text-neutral-200">
                      Lastname
                    </span>
                    <Input
                      type="text"
                      placeholder="Lastname"
                      className="mt-1 h-12 lg:h-16 rounded-xl"
                    />
                  </label>
                </div>

                <label className="block mb-2">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Email
                  </span>
                  <Input
                    type="email"
                    placeholder="example@example.com"
                    className="mt-1 h-12 lg:h-16 rounded-xl"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </label>

                <label className="block mb-2">
                  <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                    Password
                  </span>
                  <Input
                    type="password"
                    className="mt-1 h-12 lg:h-16 rounded-xl"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </label>

                <label className="block mb-2">
                  <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                    Repeat password
                  </span>
                  <Input type="password" className="mt-1 h-12 lg:h-16 rounded-xl" />
                </label>

                <ButtonPrimary
                  loading={loadingButton}
                  className="bg-primary-111"
                  type="submit"
                >
                  Registration
                </ButtonPrimary>
              </form>

              {/* ==== */}
              <span className="block text-center text-neutral-700 dark:text-neutral-300">
                Already have an account? {` `}
                <Link className="text-green-600" to="/login">
                  Log in
                </Link>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageSignUp;
